// @flow

import { combineReducers } from "redux";
import { createSelector } from "reselect";

import * as atypes from "src/constants/actionTypes";

import type { HomescreenSection, Action } from "src/types";

const metaData = (
  state: Array<HomescreenSection> = [],
  { type, payload }: Action,
) => {
  switch (type) {
    case atypes.GET_HOME_SCREEN_SUCCESS:
      return payload;
    default:
      return state;
  }
};

const myConversationChart = (state: Object = {}, { type, payload }: Action) => {
  switch (type) {
    case atypes.GET_MY_CONVERSATION_CHART_SUCCESS:
      return { ...state, [payload.tileId]: payload.metaData };
    default:
      return state;
  }
};

const loadingConversationChart = (
  state: Object = {},
  { type, payload }: Action,
) => {
  switch (type) {
    case atypes.GET_MY_CONVERSATION_CHART_REQUEST:
      return { ...state, [payload.tileId]: true };
    case atypes.GET_MY_CONVERSATION_CHART_SUCCESS:
    case atypes.GET_MY_CONVERSATION_CHART_FAILURE:
      return { ...state, [payload.tileId]: false };
    default:
      return state;
  }
};

const loading = (state: ?boolean = null, { type }: Action) => {
  switch (type) {
    case atypes.FILTER_TILE_CONVERSATIONS_SUCCESS:
    case atypes.GET_HOME_SCREEN_FAILURE:
      return false;
    default:
      return state;
  }
};

const roomsByTile = (state = {}, { payload, type }: Action) => {
  switch (type) {
    case atypes.FILTER_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        [payload.tileId]: payload.filteredRooms || [],
      };
    default:
      return state;
  }
};

export const getRoomIdsByTile = (state: Object) => {
  return state.roomsByTile;
};

export const getHomescreenSections = (state: Object) => state.metaData;

export const getIsHomescreenLoading = (state: Object) => state.loading;

export default combineReducers<Object, Action>({
  loading,
  metaData,
  myConversationChart,
  loadingConversationChart,
  roomsByTile,
});

export const getRoomsByTile = createSelector(
  [(state) => getRoomIdsByTile(state.app.homescreen), (_, tileId) => tileId],
  (roomsByTile, tileId) => {
    const roomIds = roomsByTile[tileId];
    if (!roomIds) return [];
    return roomIds;
  },
);
